export default __webpack_public_path__ + "static/media/solucao-08.83f17169.webp";